import {Component, Input, OnInit} from '@angular/core';
import {
    AssinaturaFormularioValor,
    PreenchFormularioDadosModel
} from '../../../../../model/planilhas/preench-form.model';

@Component({
    selector: 'ui-checklist-signature-field',
    standalone: false,
    templateUrl: './ui-checklist-signature-field.html',
    styleUrl: './ui-checklist-signature-field.css',
})
export class UiChecklistSignatureField implements OnInit {

    @Input() data: PreenchFormularioDadosModel;
    @Input() required = false;

    signature: AssinaturaFormularioValor = {
        nomeAssinante: '',
        cpfAssinante: '',
        imagemBase64: ''
    };

    ngOnInit(): void {
        const savedValue = this.data?.valor;

        if (savedValue && typeof savedValue === 'object') {
            this.signature = {
                nomeAssinante: savedValue.nomeAssinante ?? '',
                cpfAssinante: savedValue.cpfAssinante ?? '',
                imagemBase64: savedValue.imagemBase64 ?? '',
                caminhoImagem: savedValue.caminhoImagem,
                dataHoraAssinatura: savedValue.dataHoraAssinatura
            };
        }
    }

    get hasStoredSignature(): boolean {
        return Boolean(this.signature.caminhoImagem);
    }

    get metadataRequired(): boolean {
        const hasName = Boolean(
            this.signature.nomeAssinante?.trim()
        );

        const hasCpf = Boolean(
            this.signature.cpfAssinante?.trim()
        );

        const hasImage = Boolean(
            this.signature.imagemBase64 ||
            this.signature.caminhoImagem
        );

        return this.required || hasName || hasCpf || hasImage;
    }

    updateSignatureImage(imageBase64: string): void {
        this.signature.imagemBase64 = imageBase64;
        this.updateDataValue();
    }

    updateDataValue(): void {
        const name = this.signature.nomeAssinante?.trim() ?? '';

        const cpf = this.signature.cpfAssinante?.trim() ?? '';

        const image = this.signature.imagemBase64 ?? '';

        const storedImagePath = this.signature.caminhoImagem ?? '';

        if (!name && !cpf && !image && !storedImagePath) {
            this.data.valor = undefined;
            return;
        }

        if (storedImagePath) {
            this.data.valor = {
                nomeAssinante: name,
                cpfAssinante: cpf,
                caminhoImagem: storedImagePath,
                dataHoraAssinatura:
                this.signature.dataHoraAssinatura
            };

            return;
        }

        this.data.valor = {
            nomeAssinante: name,
            cpfAssinante: cpf,
            imagemBase64: image
        };
    }
}
